import { registerFeatureWithDescription } from "lib/features"
import { AI_MAPPING_FEEDBACK } from "routes/asset-register/plugins/asset-mapping/plugins/ai-mapping-feedback/mapping-feedback-event-definitions.mjs"

export const FEATURE_FLAG_AI_MAPPING_FEEDBACK = registerFeatureWithDescription({
    numericalId: 5006,
    id: AI_MAPPING_FEEDBACK,
    name: "AI Mapping Feedback",
    readyForProduction: true,
    descriptionLines: [
        "Captures raw feedback events when users make schedule selection decisions during Mobiliser asset mapping.",
    ],
})
